import { render, staticRenderFns } from "./SimuladorPreview.vue?vue&type=template&id=b65071e8&scoped=true"
import script from "./SimuladorPreview.vue?vue&type=script&lang=js"
export * from "./SimuladorPreview.vue?vue&type=script&lang=js"
import style0 from "./SimuladorPreview.vue?vue&type=style&index=0&id=b65071e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65071e8",
  null
  
)

export default component.exports